export class PubDtoModel {

    pubURL?: string;
    imagePath?: string;
    uuid?: string
}
